import { useCallback, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Form } from "react-bootstrap";
import { isValidEmail } from "../../../Utils/EmailValidayion";
import { postData } from "../../../axios/apiHelper";
import { loader } from "../../../loader";
import { toast } from "react-toastify";

export default function VwdProfileInvite() {
  const navigate = useNavigate();
  const location = useLocation();
  const [userList, setUserList] = useState(() => {
    if (location.state?.userList) {
      return location.state.userList.map((user) => ({
        ...user,
        errors: user.errors || { name: "", email: "" },
      }));
    }
    return [{ id: 1, name: "", email: "", errors: { name: "", email: "" } }];
  });
  const [isInternal, setIsInternal] = useState(
    location.state?.isInternal ?? null,
  );
  const [emailState, setEmailState] = useState(
    location.state?.emailState || null,
  );

  const updateUserData = (id, type, value) => {
    setUserList((prev) =>
      prev.map((user) => {
        if (user.id === id) {
          return {
            ...user,
            [type]: value,
            errors: { ...user.errors, [type]: "" },
          };
        } else return user;
      }),
    );
  };

  const removeUserData = (id) => {
    setUserList((prev) => prev.filter((user) => user.id !== id));
  };

  const addNewUser = () => {
    const idArr = [];
    userList.map((user) => idArr.push(user.id));
    const max = Math.max(...idArr);
    setUserList((prev) => {
      return [
        ...prev,
        { id: max + 1, name: "", email: "", errors: { name: "", email: "" } },
      ];
    });
  };

  const handleNextClick = useCallback(
    async (e) => {
      try {
        loader("show");
        let isValid = true;
        const obj = {};
        userList.map((u) => {
          const mail = u.email.trim();
          if (obj[mail]) obj[mail] += 1;
          else obj[mail] = 1;
        });
        const updatedUserList = userList.map((user) => {
          const errors = { name: "", email: "" };
          if (!user.name.trim()) {
            errors.name = "User Name is required";
            isValid = false;
          }
          if (!user.email.trim()) {
            errors.email = "User Email is required";
            isValid = false;
          } else if (!isValidEmail(user.email)) {
            errors.email = "Please enter a valid email address";
            isValid = false;
          } else {
          const splittedData = user.email.trim().split("@");
            // const domain = splittedData[splittedData.length - 1]?.toLowerCase();
            // const isOctapharma = domain.includes("octapharma.");

            // if (isOctapharma && !isInternal) {
            //   errors.email = "Internal option must be selected for octapharma email";
            //   isValid = false;
            // }

            // if (isInternal && !isOctapharma) {
            //   errors.email = "Internal user must have octapharma email";
            //   isValid = false;
            // }

            if (obj[user.email.trim()] > 1) {
              errors.email = "More than one user with the same email";
              isValid = false;
            }
          }
          return { ...user, errors };
        });

        if (!isValid) {
          setUserList(updatedUserList);
          loader("hide");
          return;
        }
        if (isInternal === null) {
          toast.error("Please select the user type - Internal or External", {
            closeButton: false,
          });
          loader("hide");
          return;
        }

        const response = await postData("/vwd/check-invite-email", {
          emails: userList?.map((u) => u.email.trim()),
        });

        if (response?.status === 200) {
          const data = response?.data?.data;
          if (!data?.exists) {
            loader("hide");
            navigate("/vwd/create-email", {
              state: {
                userList: userList.map(({ errors, ...user }) => user),
                isInternal,
                emailState, // Pass back any existing email state
              },
            });
          } else {
            const list = data?.message;
            const updatedUserList = userList.map((user) => {
              const errors = { name: "", email: "" };
              list.map((u) => {
                if (u?.email === user?.email.trim()) errors.email = u?.message;
              });
              return { ...user, errors };
            });
            setUserList(updatedUserList);
            loader("hide");
            return;
          }
        }
      } catch (err) {
        console.log("failed to validate user data", err);
      } finally {
        loader("hide");
      }
    },
    [userList, navigate, isInternal, emailState],
  );

  const handleBackClick = useCallback((e) => {
    navigate("/vwd/profile");
  }, []);

  const handleCancelClick = useCallback((e) => {
    navigate("/vwd/profile");
  }, []);

  const handleUserTypeChange = useCallback(
    async (nextIsInternal) => {
      setIsInternal(nextIsInternal);
    },
    [userList],
  );

  return (
    <div className="col right-sidebar vwd-profile-invite">
      <div className="custom-container">
        <div className="row">
          <div className="page-top-nav">
            <div className="row justify-content-end align-items-center">
              {/* <div className="col-12 col-md-1">
                <div className="header-btn-left">
                  <button
                    className="btn btn-primary btn-bordered back"
                    onClick={handleBackClick}
                  >
                    <Link>Back</Link>
                  </button>
                </div>
              </div> */}
              <div className="col-12 col-md-9">
                <ul className="tabnav-link">
                  <li className="active active-main">
                    <a href="">Add User</a>
                  </li>
                  <li className="">
                    <a href="">Create Your Email</a>
                  </li>
                  <li className="">
                    <a href="">Verify your Email</a>
                  </li>
                </ul>
              </div>
              <div className="col-12 col-md-2">
                <div className="header-btn">
                  <button
                    className="btn btn-primary btn-bordered move-draft"
                    onClick={handleCancelClick}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-primary btn-filled next"
                    onClick={handleNextClick}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="survey-setup d-flex w-100 mt-4 flex-column">
        <div className="page-title">
          <h2>Invited User | {userList?.length}</h2>
        </div>
        {userList?.map((user, index, userData) => {
          return (
            <AddUser
              key={user?.id}
              user={user}
              index={index}
              userData={userData}
              updateUserData={updateUserData}
              removeUserData={removeUserData}
              addNewUser={addNewUser}
              isInternal={isInternal}
              handleUserTypeChange={handleUserTypeChange}
            />
          );
        })}
      </div>
    </div>
  );
}

const AddUser = ({
  user,
  userData,
  updateUserData,
  removeUserData,
  addNewUser,
  isInternal,
  handleUserTypeChange,
  index,
}) => {
  return (
    <div className="survey-create position-relative">
      <Form className="row justify-content-between">
        <Form.Group className="col-md-5 form-group">
          <Form.Label>
            User Name <span>*</span>
          </Form.Label>
          <Form.Control
            type="text"
            name="userName"
            value={user.name}
            onChange={(e) => updateUserData(user.id, "name", e.target.value)}
            placeholder="Enter user name"
            isInvalid={!!user.errors?.name}
            className={user.errors?.name ? "error" : ""}
          />
          <div class="login-validation" type="invalid">{user.errors?.name}</div>
        </Form.Group>
        <Form.Group className="col-md-5 form-group">
          <Form.Label>
            User Email <span>*</span>
          </Form.Label>
          <Form.Control
            type="email"
            name="userEmail"
            value={user.email}
            onChange={(e) => updateUserData(user.id, "email", e.target.value)}
            placeholder="Enter user email"
            isInvalid={!!user.errors?.email}
            className={user.errors?.email ? "error" : ""}
          />
        <div class="login-validation" type="invalid">{user.errors?.email}</div>
        </Form.Group>
        <div className="col-12 user-type d-flex m-0 align-items-center">
          <span className="form-label">User type</span>
          <Form.Check
            type="radio"
            label="Internal"
            name="userType"
            id="internal"
            className="me-3"
             checked={isInternal === true}
            onChange={(e) => handleUserTypeChange(e.target.checked)}
          />
          <Form.Check
            type="radio"
            label="External"
            name="userType"
            id="external"
            checked={isInternal === false}
            onChange={(e) => handleUserTypeChange(!e.target.checked)}
          />
        </div>
      </Form>
      <div class="chapter-btn-wrapper">
        {index === userData.length - 1 && (
          <button
            type="button"
            class="btn btn-primary btn-bordered btn-voilet move-draft chappter-add-btn btn btn-primary"
            onClick={addNewUser}
          >
            Add user +
          </button>
        )}
        {userData.length > 1 && (
          <button
            type="button"
            class="dlt_btn btn btn-primary"
            onClick={() => removeUserData(user.id)}
          >
            <img
              src="https://informed.pro/componentAssets/images/delete.svg"
              alt="Delete Row"
            />
          </button>
        )}
      </div>
    </div>
  );
};
